document.addEventListener("DOMContentLoaded", function () {
  const blockedCities = ["moradabad",];
  const blockedPincodes = ["244001", "244002", "244003", "244005"]; // Add pincodes here
  const blockedCountries = ["PK"]
  const redirectURL = "/pages/content-unavailable/";
  const cacheKeyCity = "userLocation";
  const cacheKeyPostal = "userPostal";
  const cacheKeyCountry = "userCountry";
  const cacheExpiryKey = "userLocationExpiry";

  // Providers pool (randomized)
  const providers = [
    { url: "http://ipapi.co/json/", cityKey: "city", postalKey: "postal", country: "country_code" },
    // { url: "https://ipinfo.io/json?token=YOUR_TOKEN", cityKey: "city", postalKey: "postal" },
    { url: "https://ipwho.is/", cityKey: "city", postalKey: "postal", country: "country_code" },
    // { url: "http://ip-api.com/json/", cityKey: "city", postalKey: "zip" }
  ];
  const now = Date.now();
  const expiryTime = 24 * 60 * 60 * 1000; // 1 day

  function checkAndRedirect(city, postal) {

    // ✅ Prevent redirect loop
    if (window.location.pathname === redirectURL) {
      return;
    }

    if (city && blockedCities.includes(city.trim().toLowerCase())) {
      window.location.href = redirectURL;
    } else if (postal && blockedPincodes.includes(postal.trim())) {
      window.location.href = redirectURL;
    }
  }

  // // Try to load cached city
  // const cachedLocation = localStorage.getItem("userCity");

  // if (cachedLocation) {
  //   // Use cached data
  //   checkAndRedirect(cachedLocation);
  // } else {
  //   // Call API only if not cached
  //   fetch("https://ipapi.co/json/")
  //     .then(res => res.json())
  //     .then(data => {
  //       console.log(data);
  //       const city = data.city || "";
  //       localStorage.setItem("userCity", city);
  //       checkAndRedirect(city);
  //     })
  //     .catch(err => console.error("IPAPI error:", err));
  // }

  let cachedCity = localStorage.getItem(cacheKeyCity);
  let cachedPostal = localStorage.getItem(cacheKeyPostal);
  let expiry = localStorage.getItem(cacheExpiryKey);

  if ( (cachedCity || cachedPostal ) && expiry && now < parseInt(expiry)) {
    checkAndRedirect(cachedCity, cachedPostal);
  } else {
    // Pick random provider
    const provider = providers[Math.floor(Math.random() * providers.length)];

    // 🔹 Call random provider if no cache or expired
    fetch(provider.url)
      .then(res => res.json())
      .then(data => {
        const city = (data[provider.cityKey] || "").toLowerCase();
        const postal = data[provider.postalKey] || "";
        const country = data[provider.country]
        // Save in cache
        localStorage.setItem(cacheKeyCity, city);
        localStorage.setItem(cacheKeyPostal, postal);
        // localStorage.setItem(cacheKeyPostal, postal);
        localStorage.setItem(cacheExpiryKey, now + expiryTime);

        checkAndRedirect(city, postal);
      })
      .catch(err => console.error("IPAPI error:", err));
  }


});
